// import React, { useEffect, useState } from 'react';
// import { updateTimesheet } from '../core/helper/coreapicalls';

// const UpdateTimesheetForm = ({ timesheet, onUpdate, onClosePopup }) => {
//     const [formData, setFormData] = useState({
//         timesheet_time_start: '',
//         timesheet_time_signin: '',
//         timesheet_time_signout: '',
//         timesheet_time_return: '',
//         timesheet_expected_amount: 0,
//         timesheet_is_holiday: false,
//     });

//     const [validationErrors, setValidationErrors] = useState([]);

//     useEffect(() => {
//         setFormData({
//             timesheet_time_start: timesheet.timesheet_time_start || '',
//             timesheet_time_signin: timesheet.timesheet_time_signin || '',
//             timesheet_time_signout: timesheet.timesheet_time_signout || '',
//             timesheet_time_return: timesheet.timesheet_time_return || '',
//             timesheet_expected_amount: timesheet.timesheet_expected_amount || 0,
//             timesheet_is_holiday: timesheet.timesheet_is_holiday || false,
//         });
//     }, [timesheet]);

//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;
        
//         const updatedValue = type === 'checkbox' ? checked : value;
//         // const formattedTime = value ? `${value}:00` : null;
//         const formattedTime = value || null;

//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: type === 'time' ? formattedTime : updatedValue,
//         }));

//         validateTimes({
//             ...formData,
//             [name]: type === 'time' ? formattedTime : updatedValue,
//         });
//     };

//     const validateTimes = (data) => {
//         const errors = [];

//         if (data.timesheet_time_signin && data.timesheet_time_start) {
//             const startTime = new Date(`1970-01-01T${data.timesheet_time_start}`);
//             const signinTime = new Date(`1970-01-01T${data.timesheet_time_signin}`);

//             if (signinTime < startTime) {
//                 errors.push('Sign In Time cannot be before Start Time.');
//             }
//         }

//         if (data.timesheet_time_signout && data.timesheet_time_signin) {
//             const signinTime = new Date(`1970-01-01T${data.timesheet_time_signin}`);
//             const signoutTime = new Date(`1970-01-01T${data.timesheet_time_signout}`);
//             const startTime = new Date(`1970-01-01T${data.timesheet_time_start}`);

//             if (signoutTime < signinTime || signoutTime < startTime) {
//                 errors.push('Please check Sign out time');
//             }
//         }

//         if (data.timesheet_time_return && data.timesheet_time_signout) {
//             const signinTime = new Date(`1970-01-01T${data.timesheet_time_signin}`);
//             const startTime = new Date(`1970-01-01T${data.timesheet_time_start}`);
//             const signoutTime = new Date(`1970-01-01T${data.timesheet_time_signout}`);
//             const returnTime = new Date(`1970-01-01T${data.timesheet_time_return}`);

//             if (returnTime < signoutTime || returnTime < startTime || returnTime < signinTime) {
//                 errors.push('Please Check Return Time');
//             }
//         }

//         setValidationErrors(errors);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // Perform final validation before submission
//         validateTimes(formData);

//         // Wait for validationErrors to be updated
//         if (validationErrors.length > 0) {
//             alert('Please fix the following errors:\n' + validationErrors.join('\n'));
//             return; // Prevent submission if errors exist
//         }

//         // Check if the required fields are filled
//         if (
//             !formData.timesheet_time_start ||
//             !formData.timesheet_time_signin ||
//             !formData.timesheet_time_signout ||
//             !formData.timesheet_time_return
//         ) {
//             alert('Please fill in all time fields.');
//             return;
//         }

//         // Show a prompt with the entered value to the user to confirm the time
//         const confirmationMessage = `You entered the following times:\n
//         Time Start: ${formData.timesheet_time_start}\n
//         Time Sign In: ${formData.timesheet_time_signin}\n
//         Time Sign Out: ${formData.timesheet_time_signout}\n
//         Time Return: ${formData.timesheet_time_return}\n
//         Expected Amount: ${formData.timesheet_expected_amount}\n
//         Is Holiday: ${formData.timesheet_is_holiday ? 'Yes' : 'No'}`;

//         const confirmed = window.confirm(confirmationMessage);

//         if (confirmed) {
//             try {
//                 const updatedFormData = {
//                     ...formData,
//                     timesheet_save_state: true,
//                 };

//                 const updatedTimesheet = await updateTimesheet(
//                     timesheet.timesheet_id,
//                     updatedFormData
//                 );

//                 alert('Timesheet updated successfully!');
//                 window.location.reload();
//                 onUpdate(updatedTimesheet);
//             } catch (error) {
//                 console.error('Error updating timesheet:', error);
//                 alert(` ${error.message}`);
//             } finally {
//                 onClosePopup();
//             }
//         }
//     };

//     const setQuickTime = (fieldName, timeValue) => {
//     const updatedData = {
//             ...formData,
//             [fieldName]: timeValue,
//         };

//         setFormData(updatedData);
//         validateTimes(updatedData);
//     };

//     return (
//         <div className="box popup">
//             <div className="popup-content">
//                 <form onSubmit={handleSubmit}>
//                     <button className='fa fa-window-close' onClick={onClosePopup}></button>
//                     <div className="form-group">
//                         <label htmlFor="timesheet_time_start">Time Start</label><br></br>
//                         <input
//                             type="time"
//                             step="1"
//                             className="form-control input-box"
//                             id="timesheet_time_start"
//                             name="timesheet_time_start"
//                             value={formData.timesheet_time_start || ""}
//                             onChange={handleChange}
//                         />
//                         <button type="button" className="btn btn-sm btn-secondary m-1" onClick={() => setQuickTime("timesheet_time_start", "00:00:00")}>
//                             00:00:00
//                         </button>

//                         <button type="button" className="btn btn-sm btn-secondary m-1" onClick={() => setQuickTime("timesheet_time_start", "08:00:00")}>
//                             08:00:00
//                         </button>
//                     </div>

//                     <div className="form-group">
//                         <label htmlFor="timesheet_time_signin">Time Sign In</label><br></br>
//                         <input
//                             type="time"
//                             step="1"
//                             className="form-control input-box"
//                             id="timesheet_time_signin"
//                             name="timesheet_time_signin"
//                             value={formData.timesheet_time_signin || ""}
//                             onChange={handleChange}
//                         />
//                         <button type="button" className="btn btn-sm btn-secondary m-1" onClick={() => setQuickTime("timesheet_time_signin", "00:00:00")}>
//                             00:00:00
//                         </button>
                        
//                         <button type="button" className="btn btn-sm btn-secondary m-1" onClick={() => setQuickTime("timesheet_time_signin", "08:00:00")}>
//                             08:00:00
//                         </button>
//                     </div>
//                     <div className="form-group">
//                         <label htmlFor="timesheet_time_signout">Time Sign Out</label><br></br>
//                         <input
//                             className="form-control input-box"
//                             type="time"
//                             step="1"
//                             id="timesheet_time_signout"
//                             name="timesheet_time_signout"
//                             value={formData.timesheet_time_signout || ""}
//                             onChange={handleChange}
//                         />
//                         <button type="button" className="btn btn-sm btn-secondary m-1" onClick={() => setQuickTime("timesheet_time_signout", "18:00:00")}>
//                             18:00:00
//                         </button>
//                         <button type="button" className="btn btn-sm btn-secondary m-1" onClick={() => setQuickTime("timesheet_time_signout", "23:59:59")}>
//                             23:59:59
//                         </button>
//                     </div>

//                     <div className="form-group">
//                         <label htmlFor="timesheet_time_return">Time Return</label><br></br>
//                         <input
//                             className="form-control input-box"
//                             type="time"
//                             step="1"
//                             id="timesheet_time_return"
//                             name="timesheet_time_return"
//                             // value={formData.timesheet_time_return}
//                             value={formData.timesheet_time_return || ""}
//                             onChange={handleChange}
//                         />
//                         <button type="button" className="btn btn-sm btn-secondary m-1" onClick={() => setQuickTime("timesheet_time_return", "23:59:59")}>
//                             23:59:59
//                         </button>
//                     </div>

//                     <div className="form-group">
//                         <label htmlFor="timesheet_expected_amount">Expected Amount</label>
//                         <input
//                             className="form-control input-box"
//                             type="number"
//                             id="timesheet_expected_amount"
//                             name="timesheet_expected_amount"
//                             value={formData.timesheet_expected_amount}
//                             onChange={handleChange}
//                         />
//                     </div>
//                     <br></br>

//                     <div>
//                         <input
//                             type="checkbox"
//                             id="timesheet_is_holiday"
//                             name="timesheet_is_holiday"
//                             checked={formData.timesheet_is_holiday}
//                             onChange={handleChange}
//                         />
//                         <label htmlFor="timesheet_is_holiday">Is Holiday</label>
//                     </div>

//                     <div className="form-group">
//                         <button
//                             type="submit"
//                             className="btn1">
//                             Submit
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default UpdateTimesheetForm;


import React, { useEffect, useState } from "react";
import { updateTimesheet } from "../core/helper/coreapicalls";
import TimePicker24 from "../core/TimePicker24";

const UpdateTimesheetForm = ({ timesheet, onUpdate, onClosePopup }) => {
  const [formData, setFormData] = useState({
    timesheet_time_start: "",
    timesheet_time_signin: "",
    timesheet_time_signout: "",
    timesheet_time_return: "",
    timesheet_expected_amount: 0,
    timesheet_is_holiday: false,
  });

  const [validationErrors, setValidationErrors] = useState([]);

  useEffect(() => {
    setFormData({
      timesheet_time_start: timesheet.timesheet_time_start || "",
      timesheet_time_signin: timesheet.timesheet_time_signin || "",
      timesheet_time_signout: timesheet.timesheet_time_signout || "",
      timesheet_time_return: timesheet.timesheet_time_return || "",
      timesheet_expected_amount: timesheet.timesheet_expected_amount || 0,
      timesheet_is_holiday: timesheet.timesheet_is_holiday || false,
    });
  }, [timesheet]);

  const isValidTime24 = (time) => {
    return /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(time);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedValue = type === "checkbox" ? checked : value;

    const updatedData = {
      ...formData,
      [name]: updatedValue,
    };

    setFormData(updatedData);
    validateTimes(updatedData);
  };

  // TimePicker24 returns the selected/typed time directly as a string.
  const handleTimeChange = (fieldName, value) => {
    const updatedData = {
      ...formData,
      [fieldName]: value || "",
    };

    setFormData(updatedData);
    validateTimes(updatedData);
  };

  const validateTimes = (data) => {
    const errors = [];

    const timeFields = [
      ["timesheet_time_start", "Time Start"],
      ["timesheet_time_signin", "Time Sign In"],
      ["timesheet_time_signout", "Time Sign Out"],
      ["timesheet_time_return", "Time Return"],
    ];

    timeFields.forEach(([field, label]) => {
      if (data[field] && !isValidTime24(data[field])) {
        errors.push(`${label} must be a valid 24-hour time in HH:MM:SS format.`);
      }
    });

    const startValid =
      data.timesheet_time_start && isValidTime24(data.timesheet_time_start);
    const signinValid =
      data.timesheet_time_signin && isValidTime24(data.timesheet_time_signin);
    const signoutValid =
      data.timesheet_time_signout && isValidTime24(data.timesheet_time_signout);
    const returnValid =
      data.timesheet_time_return && isValidTime24(data.timesheet_time_return);

    if (startValid && signinValid) {
      const startTime = new Date(`1970-01-01T${data.timesheet_time_start}`);
      const signinTime = new Date(`1970-01-01T${data.timesheet_time_signin}`);

      if (signinTime < startTime) {
        errors.push("Sign In Time cannot be before Start Time.");
      }
    }

    if (startValid && signinValid && signoutValid) {
      const startTime = new Date(`1970-01-01T${data.timesheet_time_start}`);
      const signinTime = new Date(`1970-01-01T${data.timesheet_time_signin}`);
      const signoutTime = new Date(`1970-01-01T${data.timesheet_time_signout}`);

      if (signoutTime < signinTime || signoutTime < startTime) {
        errors.push("Please check Sign Out Time.");
      }
    }

    if (startValid && signinValid && signoutValid && returnValid) {
      const startTime = new Date(`1970-01-01T${data.timesheet_time_start}`);
      const signinTime = new Date(`1970-01-01T${data.timesheet_time_signin}`);
      const signoutTime = new Date(`1970-01-01T${data.timesheet_time_signout}`);
      const returnTime = new Date(`1970-01-01T${data.timesheet_time_return}`);

      if (
        returnTime < signoutTime ||
        returnTime < startTime ||
        returnTime < signinTime
      ) {
        errors.push("Please check Return Time.");
      }
    }

    setValidationErrors(errors);
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.timesheet_time_start ||
      !formData.timesheet_time_signin ||
      !formData.timesheet_time_signout ||
      !formData.timesheet_time_return
    ) {
      alert("Please fill in all time fields.");
      return;
    }

    const finalErrors = validateTimes(formData);

    if (finalErrors.length > 0) {
      alert("Please fix the following errors:\n" + finalErrors.join("\n"));
      return;
    }

    const confirmationMessage = `You entered the following times:

Time Start: ${formData.timesheet_time_start}
Time Sign In: ${formData.timesheet_time_signin}
Time Sign Out: ${formData.timesheet_time_signout}
Time Return: ${formData.timesheet_time_return}
Expected Amount: ${formData.timesheet_expected_amount}
Is Holiday: ${formData.timesheet_is_holiday ? "Yes" : "No"}`;

    const confirmed = window.confirm(confirmationMessage);

    if (confirmed) {
      try {
        const updatedFormData = {
          ...formData,
          timesheet_save_state: true,
        };

        const updatedTimesheet = await updateTimesheet(
          timesheet.timesheet_id,
          updatedFormData
        );

        alert("Timesheet updated successfully!");
        window.location.reload();
        onUpdate(updatedTimesheet);
      } catch (error) {
        console.error("Error updating timesheet:", error);
        alert(`${error.message}`);
      } finally {
        onClosePopup();
      }
    }
  };

  const setQuickTime = (fieldName, timeValue) => {
    handleTimeChange(fieldName, timeValue);
  };

  return (
    <div className="box popup">
      <div className="popup-content">
        <form onSubmit={handleSubmit}>
          <button
            type="button"
            className="fa fa-window-close"
            onClick={onClosePopup}
          ></button>

          <div className="form-group">
            <label>Time Start</label>
            <br />

            <TimePicker24
              value={formData.timesheet_time_start}
              onChange={(value) =>
                handleTimeChange("timesheet_time_start", value)
              }
            />

            <button
              type="button"
              className="btn btn-sm btn-secondary m-1"
              onClick={() =>
                setQuickTime("timesheet_time_start", "00:00:00")
              }
            >
              00:00:00
            </button>

            <button
              type="button"
              className="btn btn-sm btn-secondary m-1"
              onClick={() =>
                setQuickTime("timesheet_time_start", "08:00:00")
              }
            >
              08:00:00
            </button>
          </div>

          <div className="form-group">
            <label>Time Sign In</label>
            <br />

            <TimePicker24
              value={formData.timesheet_time_signin}
              onChange={(value) =>
                handleTimeChange("timesheet_time_signin", value)
              }
            />

            <button
              type="button"
              className="btn btn-sm btn-secondary m-1"
              onClick={() =>
                setQuickTime("timesheet_time_signin", "00:00:00")
              }
            >
              00:00:00
            </button>

            <button
              type="button"
              className="btn btn-sm btn-secondary m-1"
              onClick={() =>
                setQuickTime("timesheet_time_signin", "08:00:00")
              }
            >
              08:00:00
            </button>
          </div>

          <div className="form-group">
            <label>Time Sign Out</label>
            <br />

            <TimePicker24
              value={formData.timesheet_time_signout}
              onChange={(value) =>
                handleTimeChange("timesheet_time_signout", value)
              }
            />

            <button
              type="button"
              className="btn btn-sm btn-secondary m-1"
              onClick={() =>
                setQuickTime("timesheet_time_signout", "18:00:00")
              }
            >
              18:00:00
            </button>

            <button
              type="button"
              className="btn btn-sm btn-secondary m-1"
              onClick={() =>
                setQuickTime("timesheet_time_signout", "23:59:59")
              }
            >
              23:59:59
            </button>
          </div>

          <div className="form-group">
            <label>Time Return</label>
            <br />

            <TimePicker24
              value={formData.timesheet_time_return}
              onChange={(value) =>
                handleTimeChange("timesheet_time_return", value)
              }
            />

            <button
              type="button"
              className="btn btn-sm btn-secondary m-1"
              onClick={() =>
                setQuickTime("timesheet_time_return", "23:59:59")
              }
            >
              23:59:59
            </button>
          </div>

          {validationErrors.length > 0 && (
            <div
              className="alert alert-danger mt-2"
              style={{ fontSize: "12px" }}
            >
              {validationErrors.map((error, index) => (
                <div key={index}>{error}</div>
              ))}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="timesheet_expected_amount">Expected Amount</label>
            <input
              className="form-control input-box"
              type="number"
              id="timesheet_expected_amount"
              name="timesheet_expected_amount"
              value={formData.timesheet_expected_amount}
              onChange={handleChange}
            />
          </div>

          <br />

          <div>
            <input
              type="checkbox"
              id="timesheet_is_holiday"
              name="timesheet_is_holiday"
              checked={formData.timesheet_is_holiday}
              onChange={handleChange}
            />
            <label htmlFor="timesheet_is_holiday">Is Holiday</label>
          </div>

          <div className="form-group">
            <button type="submit" className="btn1">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateTimesheetForm;